import { FileTextIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FileTextGray = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FileTextIcon {...rest} size={Sizes[size]} color={fill} />;
};

FileTextGray.displayName = 'FileTextGray';
